import { IOrganizationUserData } from '../../../../../types/bussines';
import UserInformation from '../UserInformation/UserInformation';
import './OrgUsersSection.scss';

const OrgUsersSection = ({
  orgUsers,
  dataWasUpdated,
  setDataWasUpdated
}: {
  orgUsers: IOrganizationUserData[];
  dataWasUpdated: number;
  setDataWasUpdated: React.Dispatch<React.SetStateAction<number>>;
}) => {
  return (
    <div className="orgUsersSection">
      <h2 className="orgUsersTitle">Información del usuario registrado</h2>
      <div className='usersContainer'>
        {orgUsers.map(user => {
          return (
            <UserInformation
              key={`user-${user.id}-${user.lastName}`}
              userData={user}
              dataWasUpdated={dataWasUpdated}
              setDataWasUpdated={setDataWasUpdated}
            />
          );
        })}
      </div>
    </div>
  );
};

export default OrgUsersSection;
